<template>
	<div class="header">
		<h1 class="logo" style="cursor: pointer;" @click="handleLogoClick"></h1>
		<!-- 모바일 메뉴 열기 버튼 -->
		<button class="btn-alarm-mob" @click="handleMobileAlarmClick">
			<img v-if="isNewAlarm" src="@/assets/img/notification_new_icon.png" alt="알람" />
		</button>
		<button class="btn-gnb-mob" @click="gnbMob = true"></button>

		<!-- 데스크탑 네비게이션 (동적 메뉴 사용) -->
		<nav class="gnb">
			<ul>
				<li v-for="item in menuItemsMain" :key="item.menuUrl"
					:class="{ on: menuItemCurrentTopParentId === item.menuNo }">
					<button @click="goToPage(item.menuUrl); handleMenuItemCurrentTop(item);" :style="{ fontSize: locale === 'en' ? '90%' : '100%' }">
						{{lang.navigation.menuItems(String(item.menuNo)) }}
					</button>
				</li>
			</ul>
		</nav>

		<!-- 모바일 네비게이션 (퍼블리싱 디자인) -->
		<nav class="gnb-mob" v-if="gnbMob">
			<div class="gnb-mob-top">
				<h2></h2>
				<button class="btn-close" @click="gnbMob = false"></button>
			</div>
			<ul>
				<!-- 동적 메뉴 항목 -->
				<li v-for="(item, index) in menuItemsMain" :key="item.menuUrl" :class="['menu' + index]">
					<button @click="goToPage(item.menuUrl); gnbMob = false;">
						{{lang.navigation.menuItems(String(item.menuNo)) }}
					</button>
				</li>
				<!-- 추가 항목 -->
				<!-- <li @click="
					password.onConfirm = () => { togglePopup('userInfoEdit'); }
					password.isOpen = true
				">
					<button>{{ lang.title('myInfo') }}</button>
				</li> -->
				<li @click="faqPop = true">
					<button>FAQ</button>
				</li>
				<li @click="langPop = true">
					<button>{{ lang.title('languageSetting') }}</button>
				</li>
				<li @click="modePop = true">
					<button>{{ lang.title('screenSetting') }}</button>
				</li>
				<li @click="
					password.onConfirm = () => { togglePopup('userInfoEdit'); }
					password.isOpen = true
					">
					<button>{{ lang.title('myInfo') }}</button>
				</li>
				<li @click="
					handleTermsPopup();
					activePopup = 'userConsent';
				">
					<button>{{ lang.title('privacyAgreement') }}</button>
				</li>
			</ul>
			<button class="btn-logout" @click="logout">{{ lang.button('logout') }}</button>
		</nav>

		<!-- UTIL 영역 -->
		<div class="util">
			<!-- 모드 스위치 -->
			<div class="switch-mode" :class="[mode ? 'moon' : 'sun']">
				<v-checkbox v-model="mode" label="" @click="modeChg" hide-details></v-checkbox>
				<span class="cir"></span>
				<span class="ico ico1"></span>
				<span class="ico ico2"></span>
			</div>

			<!-- 데스크탑 헤더 언어 선택 -->
			<div class="language">
				<button @click="togglePopup('lang')" :class="{ down: activePopup === 'lang' }">
					<i class="ico" :class="[
              langRadio === 'ko' ? 'lang1'
                : langRadio === 'en' ? 'lang3'
                : 'lang2'
            ]"></i>
					<!-- 실제 보여줄 건 langLabel -->
					<span class="txt">{{ langLabel }}</span>
				</button>
				<div class="language-list-wrap" v-if="activePopup === 'lang'"
					v-click-outside="() => activePopup = null">
					<v-radio-group class="language-list" v-model="langRadio" hide-details>
						<ul>
							<li>
								<v-radio value="ko">
									<template #label>
										<i class="ico kor"></i>
										<span class="name">KOR</span>
										<span class="chk"></span>
									</template>
								</v-radio>
							</li>
							<li>
								<v-radio value="en">
									<template #label>
										<i class="ico usa"></i>
										<span class="name">USA</span>
										<span class="chk"></span>
									</template>
								</v-radio>
							</li>
							<li>
								<v-radio value="zh">
									<template #label>
										<i class="ico chn"></i>
										<span class="name">CHN</span>
										<span class="chk"></span>
									</template>
								</v-radio>
							</li>
						</ul>
					</v-radio-group>
				</div>
			</div>

			<!-- 회원 정보 및 마이페이지 -->
			<div class="name-mypage">
				<p class="name" @click="togglePopup('userMenu')"><span>{{ getUserName }}</span></p>
				<div class="mypage" v-if="activePopup === 'userMenu'" v-click-outside="() => activePopup = null">
					<!-- 클릭 시 팝업 종류별로 토글 -->
					<span @click="
            password.onConfirm = () => { togglePopup('userInfoEdit'); }
            password.isOpen = true
					">{{ lang.title('myInfo') }}</span>
					<span @click="togglePopup('userConsent')">{{ lang.title('privacyAgreement') }}</span>
				</div>
			</div>
			<div class="alarm-wrap">
				<div class="position-relative">
					<button class="btn-util btn-alarm" :class="{ 'btn-new-alarm': isNewAlarm }" @click="togglePopup('alarm')"></button>
				</div>
				<div class="alarm-tooltip" v-if="activePopup === 'alarm'" v-click-outside="() => togglePopup('alarm')">
					<div class="alarm-list">
						<!-- alarm-box 반복 시작 -->
						<div class="alarm-box" v-for="(alarm, idx) in allAlarmList" :key="alarm.id ?? idx">
							<div class="in">
								<div class="tit">
									<!-- 제목 분기 -->
									<strong v-if="isBoardData(alarm)">{{ alarm.boardTitle }}</strong>
									<strong v-else>{{ alarm.facility.facilityName }}</strong>

									<!-- 날짜 -->
									<span v-if="isBoardData(alarm)">{{ formatAlarmDate(alarm.createdDatetime) }}</span>
									<span v-else>{{ formatAlarmDate(alarm.faultDatetime) }}</span>
								</div>
								<!-- 공지사항 본문 vs 알람 메시지 -->
								<p v-if="isBoardData(alarm)" v-html="alarm.boardContent"></p>
								<p v-else v-html="alarm.terminal.terminalName"></p>

								<!-- 상태 텍스트 vs 알람 타입 -->
								<span class="state" v-if="isBoardData(alarm)"></span>
								<span class="state" v-else>{{ faultItem(alarm.faultItem) }}</span>
							</div>
						</div>
						<!-- alarm-box 반복 끝 -->
					</div>
				</div>
			</div>

			<!-- FAQ 버튼 -->
			<button class="btn-util btn-setting" @click="togglePopup('faq')"></button>
		</div>
	</div>

	<!-- 회원정보 수정 -->
	<div class="popup-wrap full" v-if="activePopup === 'userInfoEdit'">
		<myInfo @closePop="activePopup = null" v-click-outside="() => activePopup = null" @openWithdraw="openWithdraw">
		</myInfo>
	</div>
	<!-- 회원정보 수정 -->

	<!-- 회원 탈퇴 -->
	<div class="popup-wrap full" v-if="activePopup === 'withdraw'">
		<MyInfoWithdraw v-click-outside="() => activePopup = null" @close="openUserInfo" @closeAll="activePopup = null"
			@confirm="() => {
				activePopup = null;
				logout();
			}" />
	</div>


	<!-- 개인정보 수집/이용 동의 -->
	<div class="popup-wrap full" v-if="activePopup === 'userConsent'">
		<div class="popup" style="width:600px;" v-click-outside="() => activePopup = null">
			<div class="popup-top">
				<strong>{{ lang.title('privacyAgreement') }}</strong>
				<button class="btn-back" @click="togglePopup('userConsent')"></button>
				<button class="btn-close mob-hide" @click="togglePopup('userConsent')"></button>
			</div>
			<div class="popup-btm">
				<v-select v-model="selectedTermsId" :items="termsSelectItems" item-title="displayTitle" item-value="id"
					variant="outlined" style="max-width:400px" class="custom-select form mb--10"
					:disabled="isSelectDisabled">
				</v-select>
				<div class="clause-area">
					<div v-if="selectedTermsContent" class="terms-content" style="white-space: pre-line;">{{
						selectedTermsContent }}</div>
					<div v-else class="no-content">
						{{ lang.text('noAgreementContent') }}
					</div>
				</div>
			</div>
			<div class="popup-btn mob-hide">
				<v-btn class="custom-btn btn-blue" @click="togglePopup('userConsent')">{{ lang.button('close')
					}}</v-btn>
			</div>
		</div>
	</div>
	<!-- 개인정보 수집 및 이용동의 -->

	<!-- FAQ -->
	<div class="popup-wrap" v-if="activePopup === 'faq'">
		<div class="popup" style="width:1000px;" v-click-outside="() => activePopup = null">
			<div class="popup-top">
				<strong>FAQ</strong>
				<button class="btn-close" @click="togglePopup('faq')"></button>
			</div>
			<div class="popup-btm">
				<div class="faq-list">
					<div class="in">
						<div
							v-for="(section, sIdx) in faqItems"
							:key="sIdx"
							:style="sIdx === faqItems.length - 1 ? '' : 'padding-bottom: 22px;'"
						>
							<!-- <h3 class="faq-title">
							{{ lang.faq(`${section.category}.title`) }}
						</h3> -->
							<div
								class="faq-box"
								v-for="(qKey, qIdx) in section.questions"
								:key="`${sIdx}-${qIdx}`"
								:class="{ 'no-border': sIdx === faqItems.length - 1 && qIdx === section.questions.length - 1 }"
							>
								<div class="faq-q">
									<span class="ico">Q</span>
									<p>{{ lang.faq(`${section.category}.${qKey}`) }}</p>
								</div>
								<div class="faq-a">
									<span class="ico">A</span>
									<p v-html="lang.faq(`${section.category}.answer_${qKey.split('_')[1]}`).replaceAll('\n', '<br>')"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="popup-btn">
				<v-btn class="custom-btn btn-blue" @click="togglePopup('faq')">{{ lang.button('close') }}</v-btn>
			</div>
		</div>
	</div>
	<!-- FAQ -->

	<!-- ////////////// mobile -->
	<!-- 알람 -->
	<div class="full-popup" v-if="alarmPop">
		<div class="full-popup-top">
			<strong>{{ lang.title('alarm') }}</strong>
			<button class="btn-back" @click="handleMobileAlarmClose"></button>
		</div>
		<div class="full-popup-cont">
			<div class="alarm-list">
				<!-- alarm-box 반복 시작 -->
				<div class="alarm-box" v-for="(alarm, idx) in allAlarmList" :key="alarm.id ?? idx">
					<div class="in">
						<div class="tit">
							<!-- 제목 분기 -->
							<strong v-if="isBoardData(alarm)">{{ alarm.boardTitle }}</strong>
							<strong v-else>{{ alarm.facility.facilityName }}</strong>

							<!-- 날짜 -->
							<span v-if="isBoardData(alarm)">{{ formatAlarmDate(alarm.createdDatetime) }}</span>
							<span v-else>{{ formatAlarmDate(alarm.faultDatetime) }}</span>
						</div>
						<!-- 공지사항 본문 vs 알람 메시지 -->
						<p v-if="isBoardData(alarm)" v-html="alarm.boardContent"></p>
						<p v-else v-html="alarm.terminal.terminalName"></p>

						<!-- 상태 텍스트 vs 알람 타입 -->
						<span class="state" v-if="isBoardData(alarm)">
						</span>
						<span class="state" v-else>
							{{ faultItem(alarm.faultItem) }}
						</span>
					</div>
				</div>
				<!-- alarm-box 반복 끝 -->
			</div>
		</div>
	</div>

	<!-- FAQ -->
	<div class="full-popup" v-if="faqPop">
		<div class="full-popup-top">
			<strong>FAQ</strong>
			<button class="btn-back" @click="faqPop = false"></button>
		</div>
		<div class="full-popup-cont">
			<div class="faq-list">
				<div class="in">
					<div
						v-for="(section, sIdx) in faqItems"
						:key="sIdx"
						:style="sIdx === faqItems.length - 1 ? '' : 'padding-bottom: 22px;'"
					>
						<!-- <h3 class="faq-title">
							{{ lang.faq(`${section.category}.title`) }}
						</h3> -->
						<div
							class="faq-box"
							v-for="(qKey, qIdx) in section.questions"
							:key="`${sIdx}-${qIdx}`"
							:class="{ 'no-border': sIdx === faqItems.length - 1 && qIdx === section.questions.length - 1 }"
						>
							<div class="faq-q">
								<span class="ico">Q</span>
								<p>{{ lang.faq(`${section.category}.${qKey}`) }}</p>
							</div>
							<div class="faq-a">
								<span class="ico">A</span>
								<p v-html="lang.faq(`${section.category}.answer_${qKey.split('_')[1]}`).replaceAll('\n', '<br>')"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- 모바일 화면 언어설정 -->
	<div class="full-popup" v-if="langPop">
		<div class="full-popup-top">
			<strong>{{ lang.title('languageSetting') }}</strong>
			<button class="btn-back" @click="langPop = false"></button>
		</div>
		<div class="full-popup-cont">
			<div class="lang-list">
				<v-radio-group v-model="langRadio2" hide-details>
					<v-radio value="ko">
						<template v-slot:label>
							<span>한국어 (KOR)</span>
						</template>
					</v-radio>
					<v-radio value="en">
						<template v-slot:label>
							<span>English (USA)</span>
						</template>
					</v-radio>
					<v-radio value="zh">
						<template v-slot:label>
							<span>中文 (CHN)</span>
						</template>
					</v-radio>
				</v-radio-group>
			</div>
		</div>
	</div>

	<!-- 화면 설정 -->
	<div class="full-popup" v-if="modePop">
		<div class="full-popup-top">
			<strong>{{ lang.title('screenSetting') }}</strong>
			<button class="btn-back" @click="modePop = false"></button>
		</div>
		<div class="full-popup-cont">
			<div class="lang-list">
				<v-radio-group v-model="modeRadio" hide-details>
					<v-radio value="light">
						<template v-slot:label>
							<span>{{ lang.label('lightMode') }}</span>
						</template>
					</v-radio>
					<v-radio value="dark">
						<template v-slot:label>
							<span>{{ lang.label('darkMode') }}</span>
						</template>
					</v-radio>
				</v-radio-group>
			</div>
		</div>
		<div class="full-popup-btn">
			<v-btn class="custom-btn btn-blue" @click="confirmModeChange">{{ lang.button('confirm') }}</v-btn>
		</div>
	</div>

	<PasswordDialog v-if="password.isOpen" :isOpen="password.isOpen" @update:isOpen="val => password.isOpen = val"
		:message="password.message" :confirmText="lang.button('confirm')" @confirm="password.onConfirm()" />

</template>


<script setup lang="ts">
import {ref, onMounted, onUnmounted} from 'vue'
import {useNavigation} from "~/composables/useNavigation";
import {useDetailStore} from '~/stores/detail'
import {useAlarm} from "~/composables/useAlarm";
import {useMenu} from "~/composables/useMenu";
import {useHandleCode} from "~/composables/useHandleCode";
import {useAuth} from "~/composables/useAuth";
import {useTermsApi} from "~/composables/useTermsData";
import {useDate} from "~/composables/useDate";
import {useLanguage} from "~/composables/useLanguage";
import PasswordDialog from "~/components/passwordDialog.vue";
import {routes} from "~/constants/routes";
import MyInfoWithdraw from "~/components/myInfoWithdraw.vue";
import { useI18n } from 'vue-i18n'

const { locale, setLocale } = useI18n()

const emit = defineEmits(['click:modeChg'])

// 1) 세션스토리지에 'app-locale' 키로 보관할 ref
const storedLocale = usePersistentState<string>('app-locale', () => locale.value)

// 2) setLocale 함수 추가 (중국어 지원 추가)
const setAppLocale = async (newLocale: 'ko' | 'en' | 'zh') => {
	try {
		await setLocale(newLocale)  // i18n의 setLocale 호출
		storedLocale.value = newLocale
	} catch (error) {
		console.error('Failed to set locale:', error)
	}
}

// 3) 세션스토리지 ↔ i18n.locale 양방향 동기화 (setLocale 사용)
watch(storedLocale, async (val) => {
	if (val !== locale.value) {
		await setLocale(val as 'ko' | 'en' | 'zh')
	}
})

// locale이 외부에서 변경될 때 storedLocale 동기화
watch(locale, (val) => {
	if (val !== storedLocale.value) {
		storedLocale.value = val
	}
})

// 4) v-model 로 쓸 computed (setLocale 사용)
const langRadio = computed<string>({
	get: () => storedLocale.value,
	set: async (v) => {
		await setAppLocale(v as 'ko' | 'en' | 'zh')  // setLocale 사용
	}
})

// 5) 화면 표시용 레이블
const langLabel = computed(() => {
	switch (storedLocale.value) {
		case 'ko': return 'KOR'
		case 'en': return 'USA'
		case 'zh': return 'CHN'
		default:   return storedLocale.value.toUpperCase()
	}
})

// 6) 모바일 풀팝업용 언어 라디오 (setLocale 사용)
const langRadio2 = computed<string>({
	get: () => storedLocale.value,
	set: async (v) => {
		await setAppLocale(v as 'ko' | 'en' | 'zh')  // setLocale 사용해서 언어팩 로드
	}
})

const gnbMob = ref(false)

const alarmPop = ref(false)
const faqPop = ref(false)
const langPop = ref(false)
const modePop = ref(false)

const { getUserName, logout } = useAuth();

// password 확인 상태
const password = reactive({
  isOpen: false as boolean,
  message: '' as string,
  onConfirm: (() => {}) as () => void,
})


// ★ 팝업 상태를 하나로 관리하기 위한 변수
// 'alarm' | 'faq' | 'lang' | 'mode' | 'userInfo' 등 필요에 따라 확장
const activePopup = ref<string|null>(null)
// 버튼 클릭 시 해당 팝업 토글: 이미 열려있으면 닫고, 아니면 열기
function togglePopup(name: string) {
	if(name === 'userConsent') {
		// 약관 팝업이 열려 있으면 닫기
		if(activePopup.value === name) {
			activePopup.value = null;
			return;
		}

		// 약관 팝업을 열기 전에 사용자 동의한 약관 목록을 가져옴
		handleTermsPopup();
	}

	if(name === 'alarm') {
		// 알람 팝업이 닫힐 때만 초기화 처리
		if(activePopup.value === 'alarm') {
			// 팝업이 열려 있다가 닫히는 경우에만 알람 초기화
			clearAlarmNotifications();
		} else {
			// 알람 팝업을 열 때는 신규 알람 표시만 해제
			isNewAlarm.value = false;
		}
	}

	activePopup.value = activePopup.value === name ? null : name
}
// faultItem의 코드값
const faultItemCode = 'faultItem'
// faultItem을 언어팩으로 변환
const {handleCodeDepth, handleCode} = useHandleCode();
// faultItem을 언어팩으로 변환
const faultItem = (code: string) => {
	return handleCodeDepth(faultItemCode, code)
}

const {
	lang
} = useLanguage();

const {
	goToPage
} = useNavigation();

const {menuItemsMain, menuItemCurrentTopParentId, handleMenuItemCurrentTop} = useMenu();

// 로고 클릭 시 totalPage로 이동하면서 해당 메뉴 활성화
const handleLogoClick = () => {
	// totalPage에 해당하는 메뉴 아이템 찾기
	const totalPageMenuItem = menuItemsMain.value.find(item => item.menuUrl === routes.totalPage);
	
	if (totalPageMenuItem) {
		// 해당 메뉴를 활성화
		handleMenuItemCurrentTop(totalPageMenuItem);
	}
	
	// 페이지 이동
	goToPage(routes.totalPage);
};

const detailStore = useDetailStore()
const mode = ref(detailStore.isDark) // 초기에 store 값 반영

// detailStore.isDark와 mode ref 동기화
watch(() => detailStore.isDark, (newValue) => {
	mode.value = newValue
})

const modeChg = () => {
	emit('click:modeChg', mode)
}

const {
	isNewAlarm,
	allAlarmList,
	isBoardData,
	handleAlarmList,
	formatAlarmDate,
	clearAlarmNotifications
} = useAlarm();

const {
	// 팝업용 약관 리스트
	popupTermsList,
	// 사용자가 동의한 약관 목록 조회
	handlerFetchUserAgreedTerms,
} = useTermsApi();

const {
	formatDate
} = useDate();

// 모바일용 모드 라디오 (실제 테마와 연동)
const modeRadio = computed<string>({
	get: () => detailStore.isDark ? 'dark' : 'light',
	set: (v) => {
		detailStore.setIsDark(v === 'dark')
		mode.value = v === 'dark' // mode ref도 동기화
	}
})

// 모바일 모드 설정 확인 버튼 클릭
const confirmModeChange = () => {
	modePop.value = false // 팝업 닫기 (테마 변경은 이미 modeRadio에서 처리됨)
}

// 선택된 약관
const selectedTermsId = ref(0);

// faq 아이템 리스트 - 각 카테고리별로 묶어서 관리
const faqItems = [
  {
    category: 'introduce',
    titleKey: 'introduce.title',
    questions: ['question_1', 'question_2']
  },
  {
    category: 'accessAccount',
    titleKey: 'accessAccount.title',
    questions: ['question_1', 'question_2', 'question_3', 'question_4']
  },
  {
    category: 'alarmEvent',
    titleKey: 'alarmEvent.title',
    questions: ['question_1', 'question_2']
  },
  {
    category: 'reportHistory',
    titleKey: 'reportHistory.title',
    questions: ['question_1', 'question_2', 'question_3']
  },
  {
    category: 'maintenanceUpdate',
    titleKey: 'maintenanceUpdate.title',
    questions: ['question_1', 'question_2', 'question_3']
  }
];

// 셀렉트박스용 아이템 리스트 (제목 포함)
const termsSelectItems = computed(() => {
	// 배열이 없거나 비어있으면 빈 배열 반환
	if (!popupTermsList.value || popupTermsList.value.length === 0)
		return [
			{
				id: 0,
				displayTitle: lang.text('noAgreementContent')
			}
	];

	return popupTermsList.value
		.filter(item => item.termsAggrements && item.termsAggrements.length > 0) // 동의 정보가 있는 것만 필터링
		.map(item => {
			// 약관 타입명 가져오기
			const termsTypeName = handleCode('constant', 'TERMS_TYPE', item.termsType) || item.termsType;

			// TermsAgreements 배열에서 가장 최신 동의 정보 가져오기 (ID가 가장 큰 것)
			const latestAgreement = item.termsAggrements?.reduce((prev, current) => prev.id > current.id ? prev : current);

			// 날짜 포맷팅 (useDate 컴포저블 사용)
			const startDate = formatDate(latestAgreement?.startDate);
			const endDate = formatDate(latestAgreement?.endDate);

			// 제목 구성: "서비스 이용약관 (2024.01.01 ~ 2024.12.31)"
			let displayTitle = termsTypeName;
			if (startDate && endDate) {
				displayTitle += ` (${startDate} ~ ${endDate})`;
			} else if (startDate) {
				displayTitle += ` (${startDate} ~)`;
			}

			return {
				...item,
				displayTitle,
				latestAgreement // 나중에 사용할 수 있도록 추가
			};
		});
});

// disabled도 함께
const isSelectDisabled = computed(() => {
	return termsSelectItems.value.length === 0;
});

// 선택된 약관의 내용
const selectedTermsContent = computed(() => {
	if (!selectedTermsId.value) return ''

	const selectedItem = popupTermsList.value.find(item => item.id === selectedTermsId.value)
	if (!selectedItem) return ''

	// 현재 언어 코드에 따라 약관 내용 선택
	const langCode = locale.value || 'ko';
	switch (langCode) {
		case 'en': return selectedItem.termsContentEn || selectedItem.termsContent;
		case 'zh': return selectedItem.termsContentZh || selectedItem.termsContent;
		default: return selectedItem.termsContent;
	}
})

const handleTermsPopup = async () => {
	// 약관 팝업창을 열기 전에 사용자 동의한 약관 목록을 가져옴
	await handlerFetchUserAgreedTerms();
}

// 사용자 정보 수정 팝업 열기
function openUserInfo() {
	activePopup.value = 'userInfoEdit'
}
// 사용자 정보 수정 팝업 닫기
function openWithdraw() {
	// 회원 탈퇴 팝업 열기
	activePopup.value = 'withdraw'
}

// popupTermsList가 변경될 때마다 가장 큰 id값으로 자동 선택
watch(popupTermsList, (newTermsList) => {
	if (newTermsList && newTermsList.length > 0) {
		// id 값이 가장 큰 약관을 찾아서 선택 (최신 약관)
		const latestTerms = newTermsList.reduce((prev, current) => {
			return prev.id > current.id ? prev : current
		})

		selectedTermsId.value = latestTerms.id
	}
}, { immediate: true })

// 모바일 알람 팝업 처리 함수들
const handleMobileAlarmClick = () => {
	// 알람 팝업을 열 때는 신규 알람 표시만 해제
	isNewAlarm.value = false;
	alarmPop.value = true;
};

const handleMobileAlarmClose = () => {
	// 팝업을 닫을 때 알람 초기화
	clearAlarmNotifications();
	alarmPop.value = false;
};

// 인터벌 ID
let intervalId: ReturnType<typeof setInterval> | null = null;

onMounted(() => {
	// 알람 리스트 가져오기
	handleAlarmList();

	// 알람 리스트 주기적으로 업데이트
	intervalId = setInterval(() => {
		handleAlarmList();
	}, 1000 * 15); // 15초마다 업데이트
})

onUnmounted(() => {
	// 컴포넌트 언마운트 시 인터벌 클리어
	if (intervalId) {
		clearInterval(intervalId);
	}
})
</script>

<style lang="scss" scoped>
.alarm-wrap {
	position: relative;

	.btn-new-alarm {
		position: relative;
		width: 48px;
		height: 48px;
		background: rgba(255, 255, 255, 0.05) url('@/assets/img/ico_alarm_w.svg') no-repeat center;
		border: none;

		// 🔔 new 뱃지
		&::after {
			content: '';
			position: absolute;
			top: 6px;
			right: 6px;
			width: 16px; // 필요에 따라 이미지 크기 조정
			height: 16px;
			background: url('@/assets/img/ico_alarm_new.png') no-repeat center / contain;
			pointer-events: none;
		}
	}
}

.position-relative {
	position: relative;

	img {
		position: absolute;
		right: 0.5rem;
		top: 0.5rem;
	}
}

.faq-box.no-border {
	border-bottom: none !important;
	padding-top: 22px;
	padding-bottom: 0;
}
</style>